import {
  CreateAbtestPreviewExtension,
  DefaultChatEventExtensions,
  DefaultChatToolExtensions,
  EscalateToSupportToolExtension,
  UpdateAbtestPreviewExtension,
} from '@spotify/plugin-confidence-chat';
import { CodeBlockExtensions } from '@spotify/plugin-confidence-chat-react';
import {
  RecordingToolExtension,
  RecordingsCodeBlockExtension,
} from '@spotify/plugin-confidence-recordings';

export const DefaultCodeBlockExtensions = () => (
  <CodeBlockExtensions>
    <RecordingsCodeBlockExtension />
  </CodeBlockExtensions>
);

export const DefaultChatExtensions = () => (
  <>
    <DefaultChatEventExtensions />
    <DefaultChatToolExtensions
      toolExtensions={
        <>
          <EscalateToSupportToolExtension />
          <RecordingToolExtension />
        </>
      }
      previewExtensions={
        <>
          <UpdateAbtestPreviewExtension />
          <CreateAbtestPreviewExtension />
        </>
      }
    />
    <DefaultCodeBlockExtensions />
  </>
);
